import {
  Box,
  Button,
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { FC, Fragment, useContext, useState } from "react";
import { AllergyContext } from ".";
import AddAllergy from "./AddAllergy";
import { Close } from "@mui/icons-material";
import dayjs from "dayjs";
import EditIcon from "@mui/icons-material/Edit";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import { DeleteAllergy } from "../../services";
import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { AllergyListType } from "./types";
// import LogComonent from "../layouts/LogComonent";
import { HL7ContexTriggerContex } from "../../../context/HL7MessageTrigger/HL7MessageTriggerProvider";
import usePopup from "../../../hooks/usePopup";
import EmptyListAlert from "../layouts/EmptyListAlert";
import HistoryComponent from "../layouts/HistoryComponent";

const AllergyList: FC = () => {
  const { showSnackbar } = usePopup();
  const { encounterId } = useParams();
  const { list, edit, setEdit,setSuccess } = useContext(AllergyContext);
  const { setTrigger } = useContext(HL7ContexTriggerContex);
  const [show, setShow] = useState(false);
  const handleDelete = (id: any) => {
    if (encounterId) {
      Delete({ encounterId, id });
    }
  };


  const { mutate: Delete } = useMutation(DeleteAllergy, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 1000,
        });
        setSuccess(true)
        setTrigger({
          tab: "allergy",
          encounterId: encounterId as string,
        });
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 1000,
        });
      }
    },
  });


  return (
    <TableContainer component={Paper}>
      <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow
            sx={(theme) => ({ backgroundColor: theme.palette.primary.main })}
          >
            {heading.map((heading, index) => (
              <TableCell
                sx={(theme) => ({ color: theme.palette.background.paper })}
                align="left"
                key={`heading${index}`}
              >
                {heading.heading}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
              <EmptyListAlert
                alert="No allergies"
                isData={Boolean((list?.length || show))}
              >
                {!show && (
                  <div className="w-full flex justify-end items-center p-2 gap-3">
                    <Button
                      color="success"
                      endIcon={<AddCircleIcon />}
                      onClick={() => {
                        setShow(true);
                        setEdit(null);
                      }}
                    >
                      add
                    </Button>
                    <div>
                      {/* <LogComonent  /> */}
                      <HistoryComponent logProps={{field:"allergy",title:"Allergy"}} title="Allergy" tableprops={heading.slice(0,heading.length-2)}/>
                    </div>
                  </div>
                )}
              </EmptyListAlert>
              <Collapse in={show} timeout="auto" unmountOnExit>
                <Box>
                  <AddAllergy
                    close={() => {
                      setShow(false);
                    }}
                  />
                </Box>
              </Collapse>
            </TableCell>
          </TableRow>
          {list?.map((row: AllergyListType, index) => (
            <Fragment key={`allergyList${index}`}>
              <TableRow key={`allergy${index}`}>
                <TableCell component="th" scope="row">
                  {row?.allergen?.allergenName} (
                  {row?.allergyType?.allergyTypeName})
                </TableCell>
                <TableCell>{row?.severity?.allergySeverityName}</TableCell>
                <TableCell>
                  {row.identificationDate &&
                    dayjs(row.identificationDate, "YYYY-MM-DD", true).format(
                      "DD-MM-YYYY",
                    )}
                </TableCell>
                <TableCell>{row?.lifeCycleStatus?.description}</TableCell>
                <TableCell>
                  {Boolean(edit) && edit?.id == row.id ? (
                    <IconButton
                      color="error"
                      onClick={() => {
                        setEdit(null);
                      }}
                    >
                      <Close />
                    </IconButton>
                  ) : (
                    <>
                      <IconButton
                        color="primary"
                        onClick={() => {
                          setEdit(row);
                          setShow(false);
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                      <IconButton
                        color="error"
                        onClick={() => {
                          handleDelete(row.id);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </>
                  )}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell sx={{ padding: 0 }} colSpan={heading.length}>
                  <Collapse
                    in={Boolean(edit) && edit?.id == row.id}
                    timeout="auto"
                    unmountOnExit
                  >
                    <AddAllergy
                      close={() => {
                        setShow(false);
                      }}
                    />
                  </Collapse>
                </TableCell>
              </TableRow>
            </Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AllergyList;

// const heading = [
//   "ALLERGY DESCRIPTION",
//   "SEVERITY",
//   "IDENTIFICATION DATE",
//   "STATUS",
//   "OPTIONS",
// ];x`

const heading=[
    { heading: "ALLERGY DESCRIPTION", key: "allergen.allergenName" },
    { heading: "SEVERITY ", key: "severity.allergySeverityName" },
    { heading: "IDENTIFICATION DATE", key: "identificationDate" },
    { heading: "STATUS", key: "lifeCycleStatus.description" },
    { heading: "OPTIONS", key: "" },
]
